import { render, staticRenderFns } from "./ProcessConferenceSelect.vue?vue&type=template&id=60276588&scoped=true"
import script from "./ProcessConferenceSelect.vue?vue&type=script&lang=js"
export * from "./ProcessConferenceSelect.vue?vue&type=script&lang=js"
import style0 from "./ProcessConferenceSelect.vue?vue&type=style&index=0&id=60276588&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60276588",
  null
  
)

export default component.exports